import React, {useContext} from "react";
import {CopilotContainerLogic} from "./CopilotContainer.logic";
import {CopilotContainerRendering} from "./CopilotContainer.rendering";
import {Props} from "./CopilotContainer.interfaces";
import {AppContext, IAppContextState} from "../../../../services/AppContext";

const CopilotContainer = (props: Props): JSX.Element => {
    const context = useContext<IAppContextState>(AppContext);

    return (
        <CopilotContainerLogic {...props} teamsContext={context.teams}>
            {logic => <CopilotContainerRendering {...logic}/>}
        </CopilotContainerLogic>
    )
}

export default CopilotContainer;